import { SET_USERS_LIST } from './constants'

const initialState = {
    list: [],
    pagination: {}
}

const reducer = (state = initialState, { type, payload, error }) => {
    switch (type) {
        case SET_USERS_LIST:
            return {
                ...state,
                list: payload.users,
                pagination: payload.pagination
            }
        default:
            return state
    }
}

export default reducer
